import { PodeNaoPodeEnum } from '@mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { hasAnySim } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoPergunta18Model } from './model-consultaSeguimentoPergunta18'
import { isPergunta18ExemplosAllNao } from './utils-consultaSeguimentoPergunta18'

export const PERGUNTA_18_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta18Model> = {
  PERGUNTA_18_HEADER: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: 'PERGUNTA_18_PODE_NAO_PODE',
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: 'PERGUNTA_18_TEM_DICA_SEGUE_ORDEM',
      },
    ],
  },
  PERGUNTA_18_PODE_NAO_PODE: {
    scrollConditions: [
      {
        if: (value) => value === PodeNaoPodeEnum.PODE,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => value === PodeNaoPodeEnum.NAO_PODE,
        scrollTo: 'PERGUNTA_18_TEM_DICA_SEGUE_ORDEM',
      },
    ],
    dependsOn: 'PERGUNTA_18_HEADER',
  },
  PERGUNTA_18_TEM_DICA_SEGUE_ORDEM: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: 'PERGUNTA_18_EXEMPLOS',
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: 'PERGUNTA_18_SENTA_A_MESA',
      },
    ],
    dependsOn: 'PERGUNTA_18_HEADER',
  },
  PERGUNTA_18_EXEMPLOS: {
    scrollConditions: [
      {
        if: (value) => hasAnySim(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => isPergunta18ExemplosAllNao(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_18_TEM_DICA_SEGUE_ORDEM',
  },
  PERGUNTA_18_SENTA_A_MESA: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: 'PERGUNTA_18_EXEMPLOS',
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    dependsOn: 'PERGUNTA_18_TEM_DICA_SEGUE_ORDEM',
  },
}
